import React from 'react';
import bemit from 'Functions/bemit';
export default function getFormStatus(state = {}, modifiers = []) {
  const form_status = [{
    label: 'info',
    suffix: 'green'
  }, {
    label: 'error',
    suffix: 'red'
  }, {
    label: 'warning',
    suffix: 'orange'
  }, {
    label: 'statement',
    suffix: 'blue'
  }];

  /**
   * Map all status from component.state and return information messages accordingly.
   *
   * @param    { Object }    status_data    Infos messages to display.
   * @param    { String }    index          Iteratof.
   *
   * @return    [Array]      Renderable React elements.
   */
  let status = form_status.filter(status_data => typeof state[status_data.label] !== 'undefined').map(function (status_data, index) {
    var message = /*#__PURE__*/React.createElement("div", {
      key: index,
      className: bemit('c-message', [status_data.suffix].concat(modifiers))
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, state[status_data.label]));
    return message;
  });
  return status;
}
